import GetAdmCertified, {
  GetADMCertifiedTitle,
} from './sections/GetAdmCertified'
import CreateCoachProfile from './sections/CreateCoachProfile'
import SetUpCalendar from './sections/SetUpCalendar'
import CreateGroupEvent from './sections/CreateGroupEvent'
import CreateStudent from './sections/CreateStudent'
import SendMessage from './sections/SendMessage'
import BookNowEnabled from './sections/BookNowEnabled'
import MoreCoachTraining from './sections/MoreCoachTraining'
import SchoolOutlinedIcon from '@material-ui/icons/SchoolOutlined'

const parseStatus = (data, hasMessages) => {
  return {
    isAdmCertified: data?.currentUser?.attributes?.pgaMembership?.admCertified,
    hasCoachProfile: data?.currentUser?.attributes?.coachProfile != null,
    hasBookNowEnabled:
      data?.currentUser?.attributes?.preferences?.bookNowEnabled,
    setUpCalendar: data?.lessonTypes?.length > 0,
    hasGroupEvents: data?.currentUser?.groupEvents.length > 0,
    hasStudents: data?.currentUser?.students.length > 0,
    hasSentMessage: hasMessages,
  }
}

const parseProgress = status => {
  const numberDone = Object.keys(status).reduce((acc, cv) => {
    if (status[cv]) acc += 1
    return acc
  }, 0)
  return Math.floor((numberDone / Object.keys(status).length) * 100)
}

export const makeSteps = (data, hasMessages) => {
  const status = parseStatus(data, hasMessages)

  let { completedAdmCourseCount, totalAdmCourseCount } =
    data?.lightspeedCourseSummary || {}

  if (status.isAdmCertified) {
    completedAdmCourseCount = totalAdmCourseCount
  }

  return {
    progress: parseProgress(status),
    steps: [
      {
        id: 1,
        label: 'Get ADM Certified',
        DescriptionTitle: totalAdmCourseCount
          ? () =>
            GetADMCertifiedTitle({
              completedAdmCourseCount,
              totalAdmCourseCount,
            })
          : null,
        DescriptionComp: GetAdmCertified,
        isComplete: status.isAdmCertified,
        timeToComplete: '~3 hours',
      },
      {
        id: 2,
        label: 'Create Coach Profile',
        DescriptionComp: CreateCoachProfile,
        isComplete: status.hasCoachProfile,
        timeToComplete: '~45 mins',
      },
      {
        id: 3,
        label: 'Enable Book Now',
        DescriptionComp: BookNowEnabled,
        isComplete: status.hasBookNowEnabled,
        timeToComplete: '~1 min',
      },
      {
        id: 4,
        label: 'Set Up PGA Schedule',
        DescriptionComp: SetUpCalendar,
        isComplete: status.setUpCalendar,
        timeToComplete: '~20 mins',
        hasCoachProfile: status.hasCoachProfile,
      },
      {
        id: 5,
        label: 'Create your first Group Event',
        DescriptionComp: CreateGroupEvent,
        isComplete: status.hasGroupEvents,
        timeToComplete: '~15 mins',
      },
      {
        id: 6,
        label: 'Create your first student',
        DescriptionComp: CreateStudent,
        isComplete: status.hasStudents,
        timeToComplete: '~5 mins',
      },
      {
        id: 7,
        label: 'Send a message',
        DescriptionComp: SendMessage,
        isComplete: hasMessages,
        timeToComplete: '~2 mins',
      },
      {
        id: 8,
        label: 'More Coach Training',
        DescriptionComp: MoreCoachTraining,
        isComplete: true,
        icon: (
          <SchoolOutlinedIcon
            style={{ alignSelf: 'center' }}
            fontSize="large"
          />
        ),
      },
    ],
  }
}
